
import { validateEmail, errorLabel, getMessage, itiLoad } from './form-tools.js';

let itiLoading = false

class FormField {
  constructor (el) {
    this.input = el
    this.input.setAttribute('data-state', 'ready')
    this.required = this.input.hasAttribute('required')
    this.initSelectables()
    this.initTel()
    this.initFeedback()
    this.input.addEventListener('change', this.validate.bind(this))
    this.input.addEventListener('validate', this.validate.bind(this))
    try {
      this.input.closest('form').addEventListener('validate', this.validate.bind(this))
    } catch { }
  }
  initSelectables() {
    if (this.input.tagName == 'SELECT' || this.input.type == 'date') {
      this.updateSelectedState()
      this.input.addEventListener('change', this.updateSelectedState.bind(this))
    }
  }
  initTel() {
    if (this.input.type != 'tel') return
    try {
      if(intlTelInputGlobals) this.initIti()
    } catch {
      document.body.addEventListener('itiloaded', this.initIti.bind(this), { once: true })
      if (!itiLoading) {
        itiLoad()
        itiLoading = true
      }
    }
  }
  initIti() {
    // let elem = this.input
    this.iti = intlTelInput(this.input, {
      hiddenInput: '' + this.input.name + '_int',
      preferredCountries: ['ae','kw','sa','bh','om','qa'],
      excludeCountries: ['il'],
      separateDialCode: true,
      formatOnDisplay: true,
      autoPlaceholder: 'aggressive',
      nationalMode: true
    })
    this.input.parentNode.appendChild(this.errorDisplay)
  }
  initFeedback() {
    this.wrap = this.input.closest('.field-wrap')
    this.errorDisplay = errorLabel()
    if(this.wrap && this.input.type != 'tel') this.wrap.appendChild(this.errorDisplay)
    // this.input.parentNode.appendChild(this.errorDisplay)

  }
  clear(e) {
    this.input.value = ''
    this.input.setAttribute('data-state', 'ready')
    this.input.removeAttribute('data-error')
  }
  validate(e) {
    let empty = this.input.value == '' || this.input.value == 'n/a'
    
    if (this.required && empty)
      return this.updateState('required')
      
    if (this.input.type == 'email' && !empty && validateEmail(this.input.value) == false)
      return this.updateState('email')

    if (this.input.type == 'tel' && !empty) {
      // let tElem = window.intlTelInputGlobals.getInstance(elem)
      if(!this.iti.isValidNumber())
        return this.updateState('phone')
    }
    return this.updateState()
  }
  updateState(error) {
    if (error) {
      this.input.setAttribute('data-state', 'error')
      this.input.setAttribute('data-error', error)
      this.errorDisplay.innerHTML = getMessage(error)
    } else {
      this.input.setAttribute('data-state', 'valid')
    }
  }
  updateSelectedState(e) {
    let empty = this.input.value == '' || this.input.value == 'n/a'
    if (empty) {
      this.input.setAttribute('data-selected', 'false');
    } else {
      this.input.setAttribute('data-selected', 'true');
    }
  }
}


function init () {
  Array.from(document.querySelectorAll('input[type="text"], input[type="email"], input[type="date"], input[type="tel"], select')).forEach(elem => {
    if(!elem.hasAttribute('data-state')) {
      new FormField(elem)
    }
  })
}

document.body.addEventListener('domupdated', () => {
  init()
})

init()
